// extracted by mini-css-extract-plugin
export default {"app_profile":"About_app_profile__mmlIa","about_title":"About_about_title__vwEeW","about_products":"About_about_products__2ttFG","contacts":"About_contacts__R8+ZP"};